import React, {Component} from "react"

import {H4} from "@irati/ui/src/Typography"
import {ButtonLink} from "@irati/ui/src/Link"
import Spacing from "@irati/ui/src/Spacing"
import {Hr} from "@irati/ui/src/Layout"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"

interface Props extends InjectIntl {}

class Help extends Component<Props> {
  render() {
    const {formatMessage} = this.props
    return (
      <>
        <Hr marginTop={10} />
        <H4 marginBottom={2}>
          <FormattedMessage id="admin.containers.integrations.help.title" />
        </H4>
        <Spacing marginBottom={2}>
          <ButtonLink
            tertiary
            href={formatMessage({id: "admin.containers.integrations.help.link"})}
            target="_blank">
            <FormattedMessage id="admin.containers.integrations.help.FAQ" />
          </ButtonLink>
        </Spacing>
      </>
    )
  }
}

export default injectIntl(Help)
